import React from "react";
import { useNavigate } from "react-router-dom";
import logo from './images/Logo..png';
import { ReactComponent as HomeIcon } from './icons/home-new.svg';
import { ReactComponent as UserAddIcon } from './icons/user-add.svg';

const Layout = ({ children, mainClassName = "" }) => {
    const navigate = useNavigate();

    return (
        <div className="bg-slate-100 h-screen overflow-hidden">
            <div className="flex h-full">
                {/* Sidebar */}
                <aside className="w-24 bg-[#001621] h-full flex flex-col items-center py-4">
                    {/* Logo at top */}
                    <div className="w-full flex justify-center mt-4">
                        <img src={logo} alt="FISICO DAURLO" className="w-22 h-auto object-contain" />
                    </div>

                    {/* Middle icons - vertically centered */}
                    <div className="flex-1 flex flex-col items-center justify-center gap-6 w-full">
                        <button
                            onClick={() => navigate('/Home')}
                            aria-label="Home"
                            className="text-white p-3 rounded-full bg-white/10 hover:bg-white/20 transition-all"
                        >
                            <HomeIcon className="text-white w-6 h-6" />
                        </button>

                        <button
                            onClick={() => navigate('/create')}
                            aria-label="Add user"
                            className="text-white p-2 rounded-full bg-white/15 hover:bg-white/20 transition-all"
                        >
                            <UserAddIcon className="text-white" />
                        </button>
                    </div>

                    {/* bottom spacing */}
                    <div className="h-8" />
                </aside>

                {/* Main Content */}
                <main className={`flex-1 bg-[#F7F8FA] relative h-full overflow-y-auto ${mainClassName}`}>
                    {children}
                </main>
            </div>
        </div>
    );
};

export default Layout;
